export type Lang = 'id' | 'en'

export const translations = {
  id: {
    nav: {
      announcement:
        'sawit-net v2.0 — Modul Keuangan, Payroll & Pemasaran kini tersedia penuh',
      announcementLink: 'Lihat pembaruan',
      platform: 'Fitur',
      solutions: 'Solusi',
      integrations: 'Integrasi',
      pricing: 'Kontak',
      resources: 'Dampak',
      fitur: 'Jelajahi Fitur',
      signIn: 'Masuk',
      getStarted: 'Jadwalkan Demo',
      noCard: 'Konsultasi gratis · Tanpa komitmen awal',
    },
    hero: {
      badge: 'Sistem Manajemen Pabrik Kelapa Sawit Enterprise',
      headline1: 'Platform Operasional Terintegrasi',
      headline2: 'Pabrik Kelapa Sawit',
      subtitle:
        'sawit-net menghadirkan visibilitas end-to-end seluruh operasi PKS — dari penerimaan TBS, proses produksi, hingga pengiriman CPO. Eliminasi kebocoran, tingkatkan OER, dan kendalikan profitabilitas dengan data real-time.',
      trust1: 'Implementasi 7–14 hari kerja',
      trust2: 'Dukungan teknis 24/7',
      trust3: 'Konsultasi & demo gratis',
      cta1: 'Jadwalkan Demo Gratis',
      cta2: 'Jelajahi Fitur Lengkap',
      trustedBy: 'Dipercaya oleh pabrik kelapa sawit terkemuka di Indonesia',
      stat1Label: 'Rata-rata Efisiensi Biaya Operasional',
      stat2Label: 'Akurasi Data & Eliminasi Human Error',
      stat3Label: 'Monitoring & Dukungan Sistem',
    },
    solutions: {
      label: 'Cakupan Operasional End-to-End',
      headline: 'Satu Platform untuk Seluruh Siklus Operasi PKS',
      subtitle:
        'Dari truk pertama masuk gerbang hingga pengiriman CPO ke buyer — sawit-net mencakup setiap proses kritis dengan standar industri.',
      items: [
        {
          id: '01',
          title: 'Hulu — Penerimaan TBS',
          description:
            'Digitalisasi seluruh proses penerimaan TBS dengan sistem timbangan terintegrasi, grading otomatis, dan kontrol anti-fraud yang mencegah kebocoran sejak titik pertama.',
          features: [
            'Timbangan Digital Terintegrasi',
            'Grading & Sortasi TBS Otomatis',
            'Sistem Anti-Fraud & Audit Trail',
            'Manajemen Antrian & Jadwal Truk',
          ],
        },
        {
          id: '02',
          title: 'Tengah — Proses Produksi',
          description:
            'Pantau dan kendalikan setiap stasiun produksi secara real-time untuk memaksimalkan OER, meminimalkan losses, dan menjaga efisiensi mesin sepanjang waktu.',
          features: [
            'Monitoring Sterilizer & Thresher',
            'Kontrol Press & Klarifikasi',
            'Monitoring Boiler & Utilitas',
            'Tracking Losses per Stasiun',
          ],
        },
        {
          id: '03',
          title: 'Hilir — Pelaporan & Keuangan',
          description:
            'Laporan produksi harian, monitoring tangki CPO, manajemen pengiriman ke buyer, hingga estimasi laba rugi tersaji otomatis tanpa input manual.',
          features: [
            'Monitoring Tangki & Stok CPO/Kernel',
            'Manajemen Pengiriman & Kontrak',
            'Laporan Produksi & Rendemen Harian',
            'Dashboard Keuangan & Estimasi L/R',
          ],
        },
      ],
    },
    features: {
      label: 'Modul Sistem Terintegrasi',
      headline: 'Seluruh Kebutuhan Operasional PKS dalam Satu Sistem',
      subtitle:
        '9 modul utama yang saling terintegrasi, dirancang khusus untuk standar operasional pabrik kelapa sawit modern di Indonesia.',
      cta: 'Jelajahi Semua Modul & Fitur →',
      items: [
        {
          name: 'Supply Chain & Penerimaan TBS',
          desc: 'Manajemen penerimaan TBS dari supplier, input timbangan digital, grading, dan pembayaran supplier terintegrasi.',
        },
        {
          name: 'Produksi & Monitoring Proses',
          desc: 'Dashboard produksi real-time, tracking OER/KER, monitoring setiap stasiun, dan laporan harian otomatis.',
        },
        {
          name: 'Gudang & Inventaris Material',
          desc: 'Manajemen stok material, store request, purchase order, dan penerimaan barang dengan status otomatis.',
        },
        {
          name: 'Pemasaran & Pengiriman CPO',
          desc: 'Alur pengiriman produk ke buyer, manajemen kontrak, timbang gross, input mutu, dan riwayat invoice.',
        },
        {
          name: 'Keuangan & Laporan L/R',
          desc: 'Dashboard laba rugi bulanan, manajemen hutang piutang, kontrak aktif, dan estimasi finansial otomatis.',
        },
        {
          name: 'Payroll & Manajemen SDM',
          desc: 'Absensi & kehadiran karyawan, penggajian terintegrasi, data karyawan aktif, multi-shift, dan laporan payroll bulanan.',
        },
        {
          name: 'Absensi Karyawan',
          desc: 'Rekam kehadiran, izin, cuti, dan lembur secara digital. Terintegrasi langsung ke perhitungan payroll bulanan.',
        },
        {
          name: 'Master Data Terpusat',
          desc: 'Kelola data supplier, buyer, vendor, driver, kendaraan, dan karyawan dalam satu repositori terpusat.',
        },
        {
          name: 'Integrasi & Open API',
          desc: 'Koneksi ke sistem ERP existing, sensor IoT, timbangan digital, dan pengembangan modul custom.',
        },
      ],
    },
    dashboard: {
      label: 'Executive Dashboard',
      headline: 'Pusat Komando Digital Pabrik Anda',
      subtitle:
        'Pantau seluruh aktivitas operasional dari satu layar terpadu. Data real-time yang akurat mendukung pengambilan keputusan strategis tanpa ketergantungan pada laporan manual.',
      tabs: ['Overview', 'Storage & Tangki', 'Keuangan'],
      tabDescs: [
        'Master Data & Produksi',
        'Kapasitas & Inventaris',
        'Laba Rugi & Penggajian',
      ],
      features: [
        {
          title: 'Live Production Monitoring',
          desc: 'Throughput TBS, jam olah, dan output CPO/Kernel terpantau secara real-time setiap saat.',
        },
        {
          title: 'KPI OER & KER Otomatis',
          desc: 'Performa ekstraksi minyak dan kernel dihitung otomatis setiap jam berdasarkan data aktual.',
        },
        {
          title: 'Financial Overview Harian',
          desc: 'Estimasi profitabilitas harian berdasarkan harga CPO terkini dan biaya produksi aktual.',
        },
        {
          title: 'Losses Detection & Alert',
          desc: 'Deteksi dini kehilangan minyak di setiap stasiun produksi dengan notifikasi otomatis.',
        },
      ],
      cta: 'Lihat Semua Modul →',
    },
    mobile: {
      label: 'Aplikasi Mobile',
      headline: 'Kendali Penuh dari Genggaman Tangan',
      subtitle:
        'Akses data operasional kapan saja dan di mana saja. Lakukan approval, pantau KPI produksi, dan terima notifikasi insiden secara real-time melalui aplikasi mobile sawit-net.',
      features: [
        'Dashboard Monitoring Real-time',
        'Mobile Approval PR/PO & Dokumen',
        'Laporan Lapangan & Log Insiden',
        'Ringkasan Produksi & KPI Harian',
      ],
      cta: 'Unduh Brosur Produk',
      appHeader: 'Produksi Hari Ini',
      appOerLabel: 'OER',
      appKerLabel: 'KER',
      appAlertsTitle: 'Notifikasi Terkini',
      appAlert1: 'Tekanan Boiler 1 Tinggi',
      appAlert1Time: '10 menit lalu',
      appAlert2: 'Stok Kernel Silo Rendah',
      appAlert2Time: '45 menit lalu',
    },
    impact: {
      label: 'ROI & Dampak Bisnis',
      headline: 'Hasil Terukur yang Dirasakan Langsung',
      subtitle:
        'sawit-net dirancang untuk memberikan ROI yang jelas dan terukur. Setiap fitur dikembangkan berdasarkan tantangan nyata operasional PKS di lapangan.',
      items: [
        {
          title: 'Efisiensi Biaya Operasional',
          value: '≥20%',
          desc: 'Pengurangan biaya melalui otomasi proses dan eliminasi pemborosan',
        },
        {
          title: 'Akurasi Data Operasional',
          value: '100%',
          desc: 'Eliminasi human error dengan digitalisasi seluruh input data',
        },
        {
          title: 'Peningkatan OER',
          value: '+1–2%',
          desc: 'Peningkatan rendemen minyak melalui monitoring losses real-time',
        },
        {
          title: 'Waktu Implementasi',
          value: '7–14 Hari',
          desc: 'Go-live cepat dengan tim onboarding berpengalaman',
        },
        {
          title: 'Pengurangan Fraud & Losses',
          value: 'Signifikan',
          desc: 'Sistem anti-fraud terintegrasi di setiap titik transaksi kritis',
        },
        {
          title: 'Ketersediaan Sistem',
          value: '99.9%',
          desc: 'Uptime terjamin dengan infrastruktur cloud enterprise-grade',
        },
      ],
    },
    integration: {
      label: 'Integrasi & Infrastruktur',
      headline: 'Dirancang untuk Bekerja dengan Sistem yang Sudah Ada',
      subtitle:
        'sawit-net dapat terhubung dengan infrastruktur existing Anda — dari timbangan digital dan sensor IoT hingga sistem ERP korporat — tanpa mengganggu operasional yang berjalan.',
      ctaLink: 'Konsultasikan kebutuhan integrasi Anda →',
      items: [
        {
          title: 'ERP & Sistem Korporat',
          desc: 'Sinkronisasi data dengan SAP, Oracle, Microsoft Dynamics, atau sistem ERP internal perusahaan.',
        },
        {
          title: 'Sensor IoT & Perangkat Lapangan',
          desc: 'Kompatibel dengan sensor suhu, flow meter, load cell, dan perangkat monitoring industri lainnya.',
        },
        {
          title: 'Open API & Custom Development',
          desc: 'Arsitektur API terbuka memungkinkan pengembangan modul custom sesuai kebutuhan spesifik operasional.',
        },
        {
          title: 'Role-Based Access Control',
          desc: 'Manajemen hak akses granular berdasarkan jabatan, departemen, dan tanggung jawab operasional.',
        },
        {
          title: 'Audit Trail & Compliance',
          desc: 'Pencatatan lengkap setiap aktivitas sistem untuk kebutuhan audit internal maupun eksternal.',
        },
        {
          title: 'Deployment Fleksibel',
          desc: 'Tersedia dalam model cloud, on-premise, atau hybrid sesuai kebijakan IT dan infrastruktur perusahaan.',
        },
      ],
    },
    trust: {
      label: 'Standar Enterprise',
      headline: 'Dibangun untuk Skala, Keamanan, dan Keandalan Enterprise',
      subtitle:
        'Infrastruktur sawit-net dirancang memenuhi standar enterprise — aman, skalabel, dan siap mendukung operasi multi-pabrik.',
      stats: [
        { value: '9+', label: 'Modul Terintegrasi' },
        { value: '24/7', label: 'Dukungan Teknis' },
        { value: '99.9%', label: 'Uptime SLA' },
        { value: 'Multi', label: 'Siap Multi-PKS' },
      ],
      pillars: [
        {
          title: 'Skalabilitas Enterprise',
          desc: 'Arsitektur yang dirancang untuk mendukung operasi multi-pabrik dengan manajemen terpusat dan performa konsisten.',
        },
        {
          title: 'Keamanan Data Industrial',
          desc: 'Role-based access control, enkripsi data end-to-end, dan proteksi terhadap akses tidak sah sesuai standar industri.',
        },
        {
          title: 'Ketersediaan Tinggi',
          desc: 'SLA uptime 99.9% dengan sistem backup otomatis, failover protection, dan pemantauan infrastruktur 24/7.',
        },
      ],
      poweredBy: 'Dipercaya oleh PKS Modern di Indonesia',
    },
    cta: {
      badge: 'Mulai Transformasi Digital PKS Anda',
      headline: 'Siap Meningkatkan Efisiensi Pabrik Anda?',
      subtitle:
        'Jadwalkan sesi demo gratis bersama tim konsultan kami. Kami akan menunjukkan secara langsung bagaimana sawit-net dapat meningkatkan efisiensi dan profitabilitas operasional PKS Anda.',
      cta1: 'Jadwalkan Demo Gratis',
      cta2: 'Hubungi Tim Sales',
      trustLine:
        'Konsultasi gratis · Implementasi 7–14 hari · Dukungan onboarding penuh',
    },
    footer: {
      tagline:
        'Platform manajemen operasional enterprise untuk pabrik kelapa sawit. Dibangun untuk skala, keamanan, dan keunggulan operasional.',
      operational: 'Semua sistem berjalan normal',
      product: 'Produk',
      productLinks: [
        'Fitur & Modul',
        'Integrasi',
        'Roadmap',
        'Pembaruan',
        'Harga',
      ],
      solutions: 'Solusi',
      solutionLinks: [
        'Penerimaan TBS',
        'Monitoring Produksi',
        'Gudang & Inventaris',
        'Pemasaran & Pengiriman',
        'Keuangan & Payroll',
      ],
      company: 'Perusahaan',
      companyLinks: [
        'Tentang Kami',
        'Blog & Insight',
        'Karir',
        'Hubungi Sales',
        'Kebijakan Privasi',
        'Syarat Layanan',
      ],
      rights: 'Hak cipta dilindungi.',
    },
    fitur: {
      back: 'Kembali',
      scheduleDemo: 'Jadwalkan Demo',
      liveBadge: 'Live System Preview',
      headline: 'Jelajahi Fitur',
      headlineHighlight: 'sawit-net',
      subtitle:
        'Platform digital terintegrasi untuk modernisasi pabrik kelapa sawit Anda. Lihat langsung bagaimana setiap modul bekerja secara real-time.',
      modulesCount: '9 Modul Utama',
      realCase: '100% Real Case',
      moduleLabel: 'Modul',
      screenshotComing: 'Screenshot segera hadir',
      screenshotPreparing: 'Tampilan modul ini sedang disiapkan',
      screenshotCounter: 'Tampilan',
      ctaBadge: 'Siap Transformasi Digital?',
      ctaHeadline: 'Mulai Gunakan Sawit-NET Hari Ini',
      ctaSubtitle:
        'Hubungi tim kami dan jadwalkan sesi demo langsung. Kami akan tunjukkan bagaimana Sawit-NET bekerja untuk operasional pabrik Anda.',
      ctaWhatsapp: 'Jadwalkan Demo via WhatsApp',
      ctaBack: 'Kembali ke Beranda',
      ctaFooter: 'Konsultasi gratis · Implementasi cepat · Dukungan penuh',
      groups: [
        {
          id: 'dashboard',
          label: 'Dashboard',
          description:
            'Pusat komando digital pabrik — tampilkan ringkasan seluruh operasional dalam satu layar. Dari Master Data, Penerimaan TBS, Produksi, Storage & Tangki, Pengiriman, hingga Gudang & Inventaris, semua tersaji real-time.',
          features: [
            'Ringkasan Master Data (Supplier, Buyer, Vendor, Driver, Karyawan)',
            'Statistik Penerimaan TBS & Produksi bulanan',
            'Monitoring Storage & Tangki CPO real-time',
            'Pengiriman Product & status gudang',
            'Navigasi cepat ke semua modul',
            'Filter periode bulan/tahun',
          ],
          screens: [
            {
              title: 'Dashboard Utama — Overview',
              desc: 'Ringkasan seluruh operasional pabrik dalam satu layar — Master Data, Penerimaan TBS, Produksi, Storage & Tangki, Pengiriman, dan Gudang.',
              img: 'https://cdn.magicpatterns.com/uploads/ip26wFL1z3f1ZDoy268nqT/Screenshot_2026-02-18_at_03-04-11_HT_Group_App.png',
            },
            {
              title: 'Dashboard — Navigasi Menu Lengkap',
              desc: 'Akses cepat ke semua modul dari sidebar — Supply Chain, Produksi, Gudang, Pemasaran, Payroll, Keuangan, dan Pengaturan.',
              img: 'https://cdn.magicpatterns.com/uploads/wixmMTBa65qSQRRShk27zV/Screenshot_2026-02-18_at_03-03-38_HT_Group_App.png',
            },
            {
              title: 'Dashboard — Storage & Gudang',
              desc: 'Pantau kapasitas tangki CPO, status storage tanks (BST, CST, OT), pengiriman produk, dan ringkasan gudang & inventaris.',
              img: 'https://cdn.magicpatterns.com/uploads/1QA2djnPfUFDDy1sJNkBRn/Screenshot_2026-02-18_at_03-04-27_HT_Group_App.png',
            },
          ],
        },
        {
          id: 'master-data',
          label: 'Master Data',
          description:
            'Kelola semua data induk perusahaan dalam satu tempat — supplier, buyer, vendor, driver, material, hingga karyawan. Dilengkapi peta lokasi interaktif dan manajemen data yang terstruktur.',
          features: [
            'Manajemen Supplier dengan peta lokasi',
            'Data Buyer & Kontrak',
            'Vendor Transportir & Material',
            'Data Driver & Kendaraan',
            'Manajemen Karyawan',
          ],
          screens: [
            {
              title: 'Manajemen Supplier TBS',
              desc: 'Kelola data supplier TBS lengkap dengan peta lokasi interaktif, filter jenis pengelolaan, dan sertifikasi.',
              img: 'https://cdn.magicpatterns.com/uploads/3qvCxMp1THnSuwx9UM2LWz/Screenshot_2026-02-18_031059.png',
            },
            {
              title: 'Manajemen Vendor',
              desc: 'Kelola vendor transportir, vendor material, dan vendor bongkar dengan data kendaraan dan status pajak.',
              img: 'https://cdn.magicpatterns.com/uploads/skovRN3nsJA2wehyRNDr3X/Screenshot_2026-02-18_031305.png',
            },
          ],
        },
        {
          id: 'supply-chain',
          label: 'Supply Chain',
          description:
            'Pantau seluruh rantai pasok dari penerimaan TBS, input harga, hingga pembayaran supplier. Semua transaksi tercatat digital dengan laporan yang bisa diekspor ke Excel dan PDF.',
          features: [
            'Input Bruto, Tarra & Bongkar',
            'Filter periode & laporan otomatis',
            'Export Excel & PDF',
            'Input Harga TBS real-time',
            'Pembayaran Supplier terintegrasi',
          ],
          screens: [
            {
              title: 'Penerimaan TBS',
              desc: 'Kelola penerimaan TBS dari supplier — input data bruto, tarra, dan bongkar dengan laporan timbangan lengkap.',
              img: 'https://cdn.magicpatterns.com/uploads/uJNH8iPVAdxXvR31rFbB5Q/Screenshot_2026-02-18_031548.png',
            },
          ],
        },
        {
          id: 'produksi',
          label: 'Produksi',
          description:
            'Dashboard produksi lengkap mencakup stock TBS, proses produksi, hasil CPO/Kernel/Cangkang/Fiber, dan laporan harian. Semua data tersaji real-time per hari, bulan, dan tahun.',
          features: [
            'Dashboard produksi harian',
            'Monitoring Stock TBS',
            'Tracking proses produksi',
            'Stock Product: CPO, Kernel, Cangkang, Fiber',
            'Riwayat pergerakan stock material',
            'Laporan harian otomatis dengan export',
          ],
          screens: [
            {
              title: 'Dashboard Produksi',
              desc: 'Ringkasan operasional harian produksi — stock TBS, proses produksi, dan hasil CPO dalam satu halaman.',
              img: 'https://cdn.magicpatterns.com/uploads/8h6eADHeYq5LZga4rLsawS/Screenshot_2026-02-18_031631.png',
            },
            {
              title: 'Stock Product',
              desc: 'Pantau sisa stok produksi CPO, Kernel, Cangkang, dan Fiber beserta rincian tangki secara real-time.',
              img: 'https://cdn.magicpatterns.com/uploads/vSQ3mPiyfnL9a1NwHMW6Y4/Screenshot_2026-02-18_031651.png',
            },
            {
              title: 'Riwayat Stock Movement',
              desc: 'Tracking lengkap pergerakan stock material — masuk, keluar, dan adjustment dengan referensi transaksi.',
              img: 'https://cdn.magicpatterns.com/uploads/2PXS4STY8enSrZ2ZGQfx6L/Screenshot_2026-02-18_031936.png',
            },
            {
              title: 'Laporan Harian Produksi',
              desc: 'Laporan hasil produksi per periode — total proses, input TBS, ringkasan output CPO/Kernel/Cangkang/Fiber dengan rata-rata rendemen.',
              img: 'https://cdn.magicpatterns.com/uploads/2cgfH4h3QjsAHweM1RMAS8/Screenshot_2026-02-18_032018.png',
            },
          ],
        },
        {
          id: 'gudang',
          label: 'Gudang',
          description:
            'Manajemen gudang dan inventaris material pabrik — dari store request, purchase order, penerimaan barang, hingga pengeluaran material. Semua terpantau dengan item inventory lengkap beserta status stok.',
          features: [
            'Inventaris material dengan status Normal/Low Stock/Overstock',
            'Store Request & Purchase Request',
            'Purchase Order management',
            'Penerimaan & pengeluaran barang',
            'Filter & export data inventaris',
          ],
          screens: [
            {
              title: 'Inventaris Material',
              desc: 'Kelola master data material dan monitoring stock — lengkap dengan part number, kategori, lokasi, min/max stock, dan status otomatis.',
              img: 'https://cdn.magicpatterns.com/uploads/wGJn2VuYVdDQmDXz4ASV4m/Screenshot_2026-02-18_032050.png',
            },
          ],
        },
        {
          id: 'pemasaran',
          label: 'Pemasaran',
          description:
            'Kelola pengiriman produk CPO dan Kernel ke buyer dengan alur empat tahap yang terstruktur — dari input vendor & tarra, timbang gross, input mutu, hingga pilih kontrak. Terintegrasi dengan data produksi.',
          features: [
            'Alur pengiriman 4 tahap terstruktur',
            'Input vendor transportir & kendaraan',
            'Timbang gross & input mutu',
            'Pilih kontrak & buyer tujuan',
            'Riwayat pengiriman & invoice',
          ],
          screens: [
            {
              title: 'Pengiriman Product',
              desc: 'Kelola pengiriman produk ke buyer dengan alur empat tahap — vendor & tarra, timbang gross, input mutu, hingga pilih kontrak.',
              img: 'https://cdn.magicpatterns.com/uploads/qcjebNvs2Zx2BqhYd2Conh/Screenshot_2026-02-18_032140.png',
            },
          ],
        },
        {
          id: 'payroll',
          label: 'Payroll & SDM',
          description:
            'Sistem penggajian dan manajemen SDM terintegrasi — kelola absensi karyawan, proses penggajian bulanan, riwayat gaji, dan laporan payroll. Mendukung multi-shift dan berbagai jenis tunjangan.',
          features: [
            'Absensi & Kehadiran Karyawan',
            'Rekap Absensi Harian & Bulanan',
            'Data karyawan aktif',
            'Proses penggajian bulanan',
            'Riwayat gaji 6 bulan terakhir',
            'Multi-shift support',
            'Laporan payroll otomatis',
          ],
          screens: [
            {
              title: 'Penggajian Karyawan',
              desc: 'Pantau karyawan aktif, jumlah yang digaji bulan ini, total gaji, dan riwayat gaji 6 bulan terakhir dalam satu tampilan.',
              img: 'https://cdn.magicpatterns.com/uploads/mn1nw5YKaj1EKGGGuxaFLk/Screenshot_2026-02-18_at_03-04-44_HT_Group_App.png',
            },
          ],
        },
        {
          id: 'absensi',
          label: 'Absensi',
          description:
            'Sistem absensi karyawan digital yang terintegrasi langsung dengan modul Payroll — rekam kehadiran, izin, cuti, dan lembur secara real-time. Laporan absensi otomatis per periode untuk seluruh departemen.',
          features: [
            'Rekam kehadiran harian (masuk & keluar)',
            'Manajemen izin, cuti, dan sakit',
            'Pencatatan lembur & shift kerja',
            'Rekapitulasi absensi bulanan otomatis',
            'Integrasi langsung ke perhitungan Payroll',
            'Export laporan absensi ke Excel & PDF',
          ],
          screens: [],
        },
        {
          id: 'keuangan',
          label: 'Keuangan',
          description:
            'Laporan keuangan lengkap — laba rugi bulanan, hutang & piutang, kontrak aktif, dan stock material. Semua data finansial tersaji otomatis berdasarkan transaksi operasional.',
          features: [
            'Laporan Laba Rugi bulanan',
            'Manajemen Hutang & Piutang',
            'Kontrak aktif & nilai kontrak',
            'Stock material monitoring',
            'Estimasi finansial otomatis',
          ],
          screens: [
            {
              title: 'Keuangan & Penggajian',
              desc: 'Laporan laba rugi bulan ini, rincian pendapatan & pengeluaran, data penggajian karyawan, dan hutang piutang dalam satu dashboard.',
              img: 'https://cdn.magicpatterns.com/uploads/mn1nw5YKaj1EKGGGuxaFLk/Screenshot_2026-02-18_at_03-04-44_HT_Group_App.png',
            },
            {
              title: 'Hutang, Piutang & Kontrak',
              desc: 'Pantau status hutang & piutang, kontrak aktif beserta nilai kontrak, dan stock material secara real-time.',
              img: 'https://cdn.magicpatterns.com/uploads/9EmWVfwsUPhYQ8UymFAaQR/Screenshot_2026-02-18_at_03-04-52_HT_Group_App.png',
            },
          ],
        },
      ],
    },
    kontak: {
      back: 'Kembali',
      chatWhatsapp: 'Chat WhatsApp',
      heroBadge: 'Hubungi Kami',
      heroHeadline1: 'Kami Siap Membantu',
      heroHeadline2: 'Transformasi Digital Anda',
      heroSubtitle:
        'Konsultasi gratis, respon cepat. Tim ahli kami siap mendampingi setiap langkah modernisasi pabrik kelapa sawit Anda.',
      channelsBadge: 'Saluran Komunikasi',
      channelsHeadline: 'Pilih Cara Menghubungi Kami',
      channelsSubtitle:
        'Tersedia berbagai saluran untuk kenyamanan Anda. Respon cepat di jam kerja.',
      waTitle: 'WhatsApp Support',
      waDesc:
        'Respon tercepat untuk konsultasi dan jadwal demo. Klik nomor di bawah untuk chat langsung.',
      emailTitle: 'Email Resmi',
      emailDesc:
        'Untuk penawaran resmi, kerjasama, atau pertanyaan teknis yang lebih mendetail.',
      emailNote: 'Kami membalas dalam 1x24 jam kerja.',
      officeTitle: 'Kunjungi Kantor',
      officeDesc:
        'Diskusikan kebutuhan pabrik Anda secara langsung dengan tim ahli kami.',
      officeHours1: 'Senin – Jumat: 08.00 – 17.00',
      officeHours2: 'Sabtu: 08.00 – 12.00',
      locationBadge: 'Lokasi Kami',
      locationHeadline: 'Kantor Pusat Netkrida',
      locationDesc:
        'Berlokasi strategis di Pekanbaru, Riau — pusat industri kelapa sawit Indonesia. Kami siap melayani klien di seluruh nusantara.',
      addressLabel: 'Alamat',
      phoneLabel: 'Telepon',
      mapsButton: 'Buka di Google Maps',
      ctaBadge: 'Hubungi Kami Sekarang',
      ctaHeadline: 'Siap Tingkatkan Efisiensi PKS Anda?',
      ctaSubtitle:
        'Tim ahli kami siap membantu — dari konsultasi awal hingga implementasi penuh.',
      ctaWhatsapp: 'Konsultasi via WhatsApp',
      ctaBack: 'Kembali ke Beranda',
    },
  },
  en: {
    nav: {
      announcement:
        'sawit-net v2.0 — Finance, Payroll & Marketing modules now fully available',
      announcementLink: "See what's new",
      platform: 'Features',
      solutions: 'Solutions',
      integrations: 'Integrations',
      pricing: 'Contact',
      resources: 'Impact',
      fitur: 'Explore Features',
      signIn: 'Sign In',
      getStarted: 'Schedule a Demo',
      noCard: 'Free consultation · No upfront commitment',
    },
    hero: {
      badge: 'Enterprise Palm Oil Mill Management System',
      headline1: 'The Integrated Operations Platform for',
      headline2: 'Palm Oil Mills',
      subtitle:
        'sawit-net delivers end-to-end visibility across your entire mill operation — from FFB receiving and production processing to CPO dispatch. Eliminate losses, maximize OER, and take control of profitability with real-time data.',
      trust1: 'Implementation in 7–14 business days',
      trust2: '24/7 technical support',
      trust3: 'Free consultation & demo',
      cta1: 'Schedule a Free Demo',
      cta2: 'Explore All Features',
      trustedBy: 'Trusted by leading palm oil mills across Indonesia',
      stat1Label: 'Average Operational Cost Efficiency',
      stat2Label: 'Data Accuracy & Human Error Elimination',
      stat3Label: 'System Monitoring & Support',
    },
    solutions: {
      label: 'End-to-End Operational Coverage',
      headline: 'One Platform for the Entire Palm Oil Mill Cycle',
      subtitle:
        'From the first truck at the gate to CPO delivery to the buyer — sawit-net covers every critical process to industry standards.',
      items: [
        {
          id: '01',
          title: 'Upstream — FFB Receiving',
          description:
            'Digitize the entire FFB receiving process with integrated weighbridge systems, automated grading, and anti-fraud controls that prevent leakage from the very first touchpoint.',
          features: [
            'Integrated Digital Weighbridge',
            'Automated FFB Grading & Sorting',
            'Anti-Fraud System & Audit Trail',
            'Truck Queue & Schedule Management',
          ],
        },
        {
          id: '02',
          title: 'Midstream — Production Processing',
          description:
            'Monitor and control every production station in real-time to maximize OER, minimize losses, and maintain machine efficiency around the clock.',
          features: [
            'Sterilizer & Thresher Monitoring',
            'Press & Clarification Control',
            'Boiler & Utilities Monitoring',
            'Per-Station Losses Tracking',
          ],
        },
        {
          id: '03',
          title: 'Downstream — Reporting & Finance',
          description:
            'Daily production reports, CPO tank monitoring, buyer shipment management, and profit/loss estimates are generated automatically — no manual input required.',
          features: [
            'CPO/Kernel Tank & Stock Monitoring',
            'Shipment & Contract Management',
            'Daily Production & Extraction Reports',
            'Financial Dashboard & P&L Estimation',
          ],
        },
      ],
    },
    features: {
      label: 'Integrated System Modules',
      headline: 'All Operational Needs of a Palm Oil Mill in One System',
      subtitle:
        '9 fully integrated core modules, purpose-built for modern palm oil mill operational standards in Indonesia.',
      cta: 'Explore All Modules & Features →',
      items: [
        {
          name: 'Supply Chain & FFB Receiving',
          desc: 'Supplier FFB receiving management, digital weighbridge input, grading, and integrated supplier payment.',
        },
        {
          name: 'Production & Process Monitoring',
          desc: 'Real-time production dashboard, OER/KER tracking, per-station monitoring, and automated daily reports.',
        },
        {
          name: 'Warehouse & Material Inventory',
          desc: 'Material stock management, store requests, purchase orders, and goods receiving with automated status.',
        },
        {
          name: 'Marketing & CPO Dispatch',
          desc: 'Product delivery workflow to buyers, contract management, gross weighing, quality input, and invoice history.',
        },
        {
          name: 'Finance & P&L Reporting',
          desc: 'Monthly profit/loss dashboard, accounts payable/receivable management, active contracts, and automated financial estimates.',
        },
        {
          name: 'Payroll & HR Management',
          desc: 'Integrated employee payroll, active employee data, multi-shift support, and monthly payroll reports.',
        },
        {
          name: 'Employee Attendance',
          desc: 'Digital attendance tracking — daily check-in/out, leave, sick days, and overtime. Directly integrated with payroll calculation.',
        },
        {
          name: 'Centralized Master Data',
          desc: 'Manage supplier, buyer, vendor, driver, vehicle, and employee data in one centralized repository.',
        },
        {
          name: 'Integration & Open API',
          desc: 'Connect to existing ERP systems, IoT sensors, digital weighbridges, and develop custom modules.',
        },
      ],
    },
    dashboard: {
      label: 'Executive Dashboard',
      headline: "Your Mill's Digital Command Center",
      subtitle:
        'Monitor all operational activities from a single unified screen. Accurate real-time data supports strategic decision-making without reliance on manual daily reports.',
      tabs: ['Overview', 'Storage & Tanks', 'Finance'],
      tabDescs: [
        'Master Data & Production',
        'Capacity & Inventory',
        'P&L & Payroll',
      ],
      features: [
        {
          title: 'Live Production Monitoring',
          desc: 'FFB throughput, processing hours, and CPO/Kernel output monitored in real-time at all times.',
        },
        {
          title: 'Automated OER & KER KPIs',
          desc: 'Oil and kernel extraction rates calculated automatically every hour based on actual operational data.',
        },
        {
          title: 'Daily Financial Overview',
          desc: 'Daily profitability estimates based on current CPO prices and actual production costs.',
        },
        {
          title: 'Losses Detection & Alerts',
          desc: 'Early detection of oil losses at every production station with automated notifications.',
        },
      ],
      cta: 'View All Modules →',
    },
    mobile: {
      label: 'Mobile Application',
      headline: 'Full Control in the Palm of Your Hand',
      subtitle:
        'Access operational data anytime, anywhere. Perform approvals, monitor production KPIs, and receive incident notifications in real-time through the sawit-net mobile app.',
      features: [
        'Real-time Dashboard Monitoring',
        'Mobile PR/PO & Document Approval',
        'Field Reports & Incident Logging',
        'Daily Production Summary & KPIs',
      ],
      cta: 'Download Product Brochure',
      appHeader: "Today's Production",
      appOerLabel: 'OER',
      appKerLabel: 'KER',
      appAlertsTitle: 'Recent Alerts',
      appAlert1: 'High Pressure — Boiler 1',
      appAlert1Time: '10 mins ago',
      appAlert2: 'Low Stock — Kernel Silo',
      appAlert2Time: '45 mins ago',
    },
    impact: {
      label: 'ROI & Business Impact',
      headline: 'Measurable Results Felt Directly',
      subtitle:
        'sawit-net is designed to deliver clear, measurable ROI. Every feature is developed based on real operational challenges faced by palm oil mills in the field.',
      items: [
        {
          title: 'Operational Cost Efficiency',
          value: '≥20%',
          desc: 'Cost reduction through process automation and waste elimination',
        },
        {
          title: 'Operational Data Accuracy',
          value: '100%',
          desc: 'Human error elimination through full digitization of data input',
        },
        {
          title: 'OER Improvement',
          value: '+1–2%',
          desc: 'Oil extraction rate improvement through real-time losses monitoring',
        },
        {
          title: 'Implementation Timeline',
          value: '7–14 Days',
          desc: 'Fast go-live with an experienced onboarding team',
        },
        {
          title: 'Fraud & Losses Reduction',
          value: 'Significant',
          desc: 'Integrated anti-fraud system at every critical transaction point',
        },
        {
          title: 'System Availability',
          value: '99.9%',
          desc: 'Guaranteed uptime with enterprise-grade cloud infrastructure',
        },
      ],
    },
    integration: {
      label: 'Integration & Infrastructure',
      headline: 'Designed to Work with Your Existing Systems',
      subtitle:
        'sawit-net can connect with your existing infrastructure — from digital weighbridges and IoT sensors to corporate ERP systems — without disrupting ongoing operations.',
      ctaLink: 'Discuss your integration requirements →',
      items: [
        {
          title: 'ERP & Corporate Systems',
          desc: "Data synchronization with SAP, Oracle, Microsoft Dynamics, or your company's internal ERP system.",
        },
        {
          title: 'IoT Sensors & Field Devices',
          desc: 'Compatible with temperature sensors, flow meters, load cells, and other industrial monitoring devices.',
        },
        {
          title: 'Open API & Custom Development',
          desc: 'Open API architecture enables custom module development tailored to specific operational requirements.',
        },
        {
          title: 'Role-Based Access Control',
          desc: 'Granular access rights management based on job title, department, and operational responsibilities.',
        },
        {
          title: 'Audit Trail & Compliance',
          desc: 'Complete logging of all system activities for internal and external audit requirements.',
        },
        {
          title: 'Flexible Deployment',
          desc: 'Available in cloud, on-premise, or hybrid models to match your IT policy and infrastructure.',
        },
      ],
    },
    trust: {
      label: 'Enterprise Standard',
      headline: 'Built for Enterprise Scale, Security, and Reliability',
      subtitle:
        "sawit-net's infrastructure is designed to meet enterprise standards — secure, scalable, and ready to support multi-mill operations.",
      stats: [
        { value: '9+', label: 'Integrated Modules' },
        { value: '24/7', label: 'Technical Support' },
        { value: '99.9%', label: 'Uptime SLA' },
        { value: 'Multi', label: 'Multi-Mill Ready' },
      ],
      pillars: [
        {
          title: 'Enterprise Scalability',
          desc: 'Architecture designed to support multi-mill operations with centralized management and consistent performance.',
        },
        {
          title: 'Industrial Data Security',
          desc: 'Role-based access control, end-to-end data encryption, and protection against unauthorized access to industry standards.',
        },
        {
          title: 'High Availability',
          desc: '99.9% uptime SLA with automated backup systems, failover protection, and 24/7 infrastructure monitoring.',
        },
      ],
      poweredBy: 'Trusted by Modern Palm Oil Mills in Indonesia',
    },
    cta: {
      badge: "Start Your Mill's Digital Transformation",
      headline: "Ready to Improve Your Mill's Efficiency?",
      subtitle:
        "Schedule a free demo session with our consultant team. We\'ll show you firsthand how sawit-net can improve the efficiency and profitability of your palm oil mill operations.",
      cta1: 'Schedule a Free Demo',
      cta2: 'Contact Sales Team',
      trustLine:
        'Free consultation · Implementation in 7–14 days · Full onboarding support',
    },
    footer: {
      tagline:
        'Enterprise operational management platform for palm oil mills. Built for scale, security, and operational excellence.',
      operational: 'All systems operational',
      product: 'Product',
      productLinks: [
        'Features & Modules',
        'Integrations',
        'Roadmap',
        'Updates',
        'Pricing',
      ],
      solutions: 'Solutions',
      solutionLinks: [
        'FFB Receiving',
        'Production Monitoring',
        'Warehouse & Inventory',
        'Marketing & Dispatch',
        'Finance & Payroll',
      ],
      company: 'Company',
      companyLinks: [
        'About Us',
        'Blog & Insights',
        'Careers',
        'Contact Sales',
        'Privacy Policy',
        'Terms of Service',
      ],
      rights: 'All rights reserved.',
    },
    fitur: {
      back: 'Back',
      scheduleDemo: 'Schedule Demo',
      liveBadge: 'Live System Preview',
      headline: 'Explore',
      headlineHighlight: 'sawit-net Features',
      subtitle:
        'An integrated digital platform for modernizing your palm oil mill. See firsthand how each module works in real-time.',
      modulesCount: '9 Core Modules',
      realCase: '100% Real Case',
      moduleLabel: 'Module',
      screenshotComing: 'Screenshot coming soon',
      screenshotPreparing: 'This module view is being prepared',
      screenshotCounter: 'Views',
      ctaBadge: 'Ready for Digital Transformation?',
      ctaHeadline: 'Start Using Sawit-NET Today',
      ctaSubtitle:
        'Contact our team and schedule a live demo session. We will show you how Sawit-NET works for your mill operations.',
      ctaWhatsapp: 'Schedule Demo via WhatsApp',
      ctaBack: 'Back to Home',
      ctaFooter: 'Free consultation · Fast implementation · Full support',
      groups: [
        {
          id: 'dashboard',
          label: 'Dashboard',
          description:
            "The mill's digital command center — display a summary of all operations on one screen. From Master Data, FFB Receiving, Production, Storage & Tanks, Dispatch, to Warehouse & Inventory, all presented in real-time.",
          features: [
            'Master Data Summary (Supplier, Buyer, Vendor, Driver, Employee)',
            'Monthly FFB Receiving & Production Statistics',
            'Real-time CPO Storage & Tank Monitoring',
            'Product Dispatch & Warehouse Status',
            'Quick navigation to all modules',
            'Month/year period filter',
          ],
          screens: [
            {
              title: 'Main Dashboard — Overview',
              desc: 'Summary of all mill operations on one screen — Master Data, FFB Receiving, Production, Storage & Tanks, Dispatch, and Warehouse.',
              img: 'https://cdn.magicpatterns.com/uploads/ip26wFL1z3f1ZDoy268nqT/Screenshot_2026-02-18_at_03-04-11_HT_Group_App.png',
            },
            {
              title: 'Dashboard — Full Menu Navigation',
              desc: 'Quick access to all modules from the sidebar — Supply Chain, Production, Warehouse, Marketing, Payroll, Finance, and Settings.',
              img: 'https://cdn.magicpatterns.com/uploads/wixmMTBa65qSQRRShk27zV/Screenshot_2026-02-18_at_03-03-38_HT_Group_App.png',
            },
            {
              title: 'Dashboard — Storage & Warehouse',
              desc: 'Monitor CPO tank capacity, storage tank status (BST, CST, OT), product dispatch, and warehouse & inventory summary.',
              img: 'https://cdn.magicpatterns.com/uploads/1QA2djnPfUFDDy1sJNkBRn/Screenshot_2026-02-18_at_03-04-27_HT_Group_App.png',
            },
          ],
        },
        {
          id: 'master-data',
          label: 'Master Data',
          description:
            'Manage all company master data in one place — suppliers, buyers, vendors, drivers, materials, and employees. Complete with interactive location maps and structured data management.',
          features: [
            'Supplier management with location map',
            'Buyer & Contract Data',
            'Transport & Material Vendors',
            'Driver & Vehicle Data',
            'Employee Management',
          ],
          screens: [
            {
              title: 'FFB Supplier Management',
              desc: 'Manage FFB supplier data with interactive location maps, management type filters, and certifications.',
              img: 'https://cdn.magicpatterns.com/uploads/3qvCxMp1THnSuwx9UM2LWz/Screenshot_2026-02-18_031059.png',
            },
            {
              title: 'Vendor Management',
              desc: 'Manage transport vendors, material vendors, and unloading vendors with vehicle data and tax status.',
              img: 'https://cdn.magicpatterns.com/uploads/skovRN3nsJA2wehyRNDr3X/Screenshot_2026-02-18_031305.png',
            },
          ],
        },
        {
          id: 'supply-chain',
          label: 'Supply Chain',
          description:
            'Monitor the entire supply chain from FFB receiving, price input, to supplier payment. All transactions are digitally recorded with reports exportable to Excel and PDF.',
          features: [
            'Gross, Tare & Unloading Input',
            'Period filter & automated reports',
            'Excel & PDF Export',
            'Real-time FFB Price Input',
            'Integrated Supplier Payment',
          ],
          screens: [
            {
              title: 'FFB Receiving',
              desc: 'Manage FFB receiving from suppliers — input gross, tare, and unloading data with complete weighbridge reports.',
              img: 'https://cdn.magicpatterns.com/uploads/uJNH8iPVAdxXvR31rFbB5Q/Screenshot_2026-02-18_031548.png',
            },
          ],
        },
        {
          id: 'produksi',
          label: 'Production',
          description:
            'Complete production dashboard covering FFB stock, production process, CPO/Kernel/Shell/Fiber output, and daily reports. All data presented in real-time per day, month, and year.',
          features: [
            'Daily production dashboard',
            'FFB Stock Monitoring',
            'Production process tracking',
            'Product Stock: CPO, Kernel, Shell, Fiber',
            'Material stock movement history',
            'Automated daily reports with export',
          ],
          screens: [
            {
              title: 'Production Dashboard',
              desc: 'Daily production operational summary — FFB stock, production process, and CPO output on one page.',
              img: 'https://cdn.magicpatterns.com/uploads/8h6eADHeYq5LZga4rLsawS/Screenshot_2026-02-18_031631.png',
            },
            {
              title: 'Product Stock',
              desc: 'Monitor remaining CPO, Kernel, Shell, and Fiber production stock with real-time tank details.',
              img: 'https://cdn.magicpatterns.com/uploads/vSQ3mPiyfnL9a1NwHMW6Y4/Screenshot_2026-02-18_031651.png',
            },
            {
              title: 'Stock Movement History',
              desc: 'Complete tracking of material stock movements — in, out, and adjustments with transaction references.',
              img: 'https://cdn.magicpatterns.com/uploads/2PXS4STY8enSrZ2ZGQfx6L/Screenshot_2026-02-18_031936.png',
            },
            {
              title: 'Daily Production Report',
              desc: 'Production output report per period — total processing, FFB input, CPO/Kernel/Shell/Fiber output summary with average extraction rates.',
              img: 'https://cdn.magicpatterns.com/uploads/2cgfH4h3QjsAHweM1RMAS8/Screenshot_2026-02-18_032018.png',
            },
          ],
        },
        {
          id: 'gudang',
          label: 'Warehouse',
          description:
            'Mill material warehouse and inventory management — from store requests, purchase orders, goods receiving, to material issuance. All monitored with complete inventory items and stock status.',
          features: [
            'Material inventory with Normal/Low Stock/Overstock status',
            'Store Request & Purchase Request',
            'Purchase Order management',
            'Goods receiving & issuance',
            'Filter & export inventory data',
          ],
          screens: [
            {
              title: 'Material Inventory',
              desc: 'Manage material master data and stock monitoring — complete with part number, category, location, min/max stock, and automated status.',
              img: 'https://cdn.magicpatterns.com/uploads/wGJn2VuYVdDQmDXz4ASV4m/Screenshot_2026-02-18_032050.png',
            },
          ],
        },
        {
          id: 'pemasaran',
          label: 'Marketing',
          description:
            'Manage CPO and Kernel product delivery to buyers with a structured four-stage workflow — from vendor & tare input, gross weighing, quality input, to contract selection. Integrated with production data.',
          features: [
            'Structured 4-stage delivery workflow',
            'Transport vendor & vehicle input',
            'Gross weighing & quality input',
            'Contract & destination buyer selection',
            'Delivery history & invoices',
          ],
          screens: [
            {
              title: 'Product Dispatch',
              desc: 'Manage product delivery to buyers with a four-stage workflow — vendor & tare, gross weighing, quality input, to contract selection.',
              img: 'https://cdn.magicpatterns.com/uploads/qcjebNvs2Zx2BqhYd2Conh/Screenshot_2026-02-18_032140.png',
            },
          ],
        },
        {
          id: 'payroll',
          label: 'Payroll & HR',
          description:
            'Integrated payroll and HR management system — manage employee attendance, monthly payroll processing, salary history, and payroll reports. Supports multi-shift and various allowance types.',
          features: [
            'Employee Attendance & Presence',
            'Daily & Monthly Attendance Recap',
            'Active employee data',
            'Monthly payroll processing',
            'Last 6 months salary history',
            'Multi-shift support',
            'Automated payroll reports',
          ],
          screens: [
            {
              title: 'Employee Payroll',
              desc: 'Monitor active employees, number paid this month, total salary, and last 6 months salary history in one view.',
              img: 'https://cdn.magicpatterns.com/uploads/mn1nw5YKaj1EKGGGuxaFLk/Screenshot_2026-02-18_at_03-04-44_HT_Group_App.png',
            },
          ],
        },
        {
          id: 'absensi',
          label: 'Attendance',
          description:
            'Digital employee attendance system directly integrated with the Payroll module — record attendance, leave, sick days, and overtime in real-time. Automated attendance reports per period for all departments.',
          features: [
            'Daily attendance recording (check-in & check-out)',
            'Leave, sick day, and absence management',
            'Overtime & shift recording',
            'Automated monthly attendance recap',
            'Direct integration with Payroll calculation',
            'Export attendance reports to Excel & PDF',
          ],
          screens: [],
        },
        {
          id: 'keuangan',
          label: 'Finance',
          description:
            'Complete financial reports — monthly profit/loss, accounts payable & receivable, active contracts, and material stock. All financial data presented automatically based on operational transactions.',
          features: [
            'Monthly Profit & Loss Report',
            'Accounts Payable & Receivable Management',
            'Active contracts & contract values',
            'Material stock monitoring',
            'Automated financial estimates',
          ],
          screens: [
            {
              title: 'Finance & Payroll',
              desc: "This month's profit/loss report, revenue & expense breakdown, employee payroll data, and accounts payable/receivable in one dashboard.",
              img: 'https://cdn.magicpatterns.com/uploads/mn1nw5YKaj1EKGGGuxaFLk/Screenshot_2026-02-18_at_03-04-44_HT_Group_App.png',
            },
            {
              title: 'Payables, Receivables & Contracts',
              desc: 'Monitor accounts payable & receivable status, active contracts with contract values, and material stock in real-time.',
              img: 'https://cdn.magicpatterns.com/uploads/9EmWVfwsUPhYQ8UymFAaQR/Screenshot_2026-02-18_at_03-04-52_HT_Group_App.png',
            },
          ],
        },
      ],
    },
    kontak: {
      back: 'Back',
      chatWhatsapp: 'Chat on WhatsApp',
      heroBadge: 'Contact Us',
      heroHeadline1: 'We Are Ready to Help',
      heroHeadline2: 'Your Digital Transformation',
      heroSubtitle:
        'Free consultation, fast response. Our expert team is ready to guide every step of your palm oil mill modernization.',
      channelsBadge: 'Communication Channels',
      channelsHeadline: 'Choose How to Reach Us',
      channelsSubtitle:
        'Multiple channels available for your convenience. Fast response during business hours.',
      waTitle: 'WhatsApp Support',
      waDesc:
        'Fastest response for consultations and demo scheduling. Click a number below to chat directly.',
      emailTitle: 'Official Email',
      emailDesc:
        'For official proposals, partnerships, or more detailed technical inquiries.',
      emailNote: 'We respond within 1 business day.',
      officeTitle: 'Visit Our Office',
      officeDesc: 'Discuss your mill needs in person with our expert team.',
      officeHours1: 'Monday – Friday: 08:00 – 17:00',
      officeHours2: 'Saturday: 08:00 – 12:00',
      locationBadge: 'Our Location',
      locationHeadline: 'Netkrida Head Office',
      locationDesc:
        "Strategically located in Pekanbaru, Riau — the heart of Indonesia's palm oil industry. We serve clients across the archipelago.",
      addressLabel: 'Address',
      phoneLabel: 'Phone',
      mapsButton: 'Open in Google Maps',
      ctaBadge: 'Contact Us Now',
      ctaHeadline: 'Ready to Improve Your Mill Efficiency?',
      ctaSubtitle:
        'Our expert team is ready to help — from initial consultation to full implementation.',
      ctaWhatsapp: 'Consult via WhatsApp',
      ctaBack: 'Back to Home',
    },
  },
} as const
